package ai.beakman.undercover.i18n

import ai.beakman.undercover.Identity
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/** Mapeia um [Language] para a sua implementação de [Strings]. */
fun Language.strings(): Strings = when (this) {
    Language.EN -> StringsEn
    Language.PT -> StringsPt
    Language.ES -> StringsEs
}

/**
 * Estado global de idioma do app.
 *
 * Inicializa a partir do idioma persistido em [Identity] (se houver); caso contrário,
 * detecta o idioma do sistema. A UI reage via [language] (`collectAsState`); textos
 * são lidos de [strings].
 */
object I18n {
    private val initial: Language =
        Language.fromCode(Identity.loadLanguage() ?: detectSystemLanguage().code)

    private val _language = MutableStateFlow(initial)

    /** Flow do idioma corrente — a UI coleta para recompor ao trocar de idioma. */
    val language: StateFlow<Language> = _language.asStateFlow()

    /** Idioma corrente (snapshot). */
    val current: Language get() = _language.value

    /** Textos da UI no idioma corrente. */
    val strings: Strings get() = current.strings()

    /** Troca o idioma e persiste a escolha para as próximas sessões. */
    fun setLanguage(l: Language) {
        _language.value = l
        Identity.persistLanguage(l.code)
    }
}

/** Idioma do sistema (plataforma-específico), mapeado via [Language.fromCode]. */
expect fun detectSystemLanguage(): Language
